const getLngOptionsURLParam = () => {
  const urlParams =  new URLSearchParams(window.location.search);
  return urlParams.get('lng_options') || null;
}

export {getLngOptionsURLParam};